// extracted by mini-css-extract-plugin
export default {"typing_indicator":"Loading_typing_indicator__RGdqV","dot":"Loading_dot__tiypB","typing-animation":"Loading_typing-animation__C3ryo"};